import React from 'react'
import Experiment from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { Banner as PromoBanner } from '../../../components/Banner'
import { EXPERIMENT_FLAG_KEY } from '../constants'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'

// Productization note: We should add `showPromo: true` to the gift page component settings
// instead of adding the promo banner where this wrapper is being used.
export const Pen5108PromoBannerWrapper = () => {
  const { pathname } = useStaticData<{ pathname: string }>()
  const { experimentCriteria } = useExperimentCriteria()

  if (!experimentCriteria) return <></>

  return (
    <Experiment
      name={EXPERIMENT_FLAG_KEY}
      variant_1={() => <PromoBanner pathname={pathname} />}
      track={false}
    />
  )
}
